import type { SurveyAdminRecord, SurveyWriteInput } from '../types';
import { apiFetch } from '../../../../common/api/apiFetchClient';

const BASE = '/api/rfi/surveys';

export const surveysApi = {
  listSurveys(): Promise<{ surveys: SurveyAdminRecord[] }> {
    return apiFetch(`${BASE}`);
  },

  getSurvey(surveyId: number): Promise<{ survey: SurveyAdminRecord }> {
    return apiFetch(`${BASE}/${surveyId}`);
  },

  createSurvey(body: SurveyWriteInput): Promise<{ surveyId: number }> {
    return apiFetch(`${BASE}`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  updateSurvey(surveyId: number, body: SurveyWriteInput): Promise<{ surveyId: number }> {
    return apiFetch(`${BASE}/${surveyId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

  deleteSurvey(surveyId: number): Promise<{ surveyId: number }> {
    return apiFetch(`${BASE}/${surveyId}`, { method: 'DELETE' });
  },

  reactivateSurvey(surveyId: number, endDate: string): Promise<{ surveyId: number }> {
    return apiFetch(`${BASE}/${surveyId}/activate`, {
      method: 'POST',
      body: JSON.stringify({ endDate }),
    });
  },
};
